/* Eve & Morrow. The behaviour the approved build needs, on Shopify's own cart.

   The design review build kept its cart in localStorage. Here every figure in
   the drawer comes back from /cart.js, so what the drawer shows is what the
   checkout charges (law 7). Prices arrive as integers in the shop's minor unit
   and are formatted with the shop's own money format, never recalculated. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var FMT = window.EM_MONEY_FORMAT || '${{amount}}';
  var FREE = window.EM_FREE_SHIPPING || 0;          /* minor units, 0 = no bar */
  var UPSELL = window.EM_UPSELL || [];

  /* Shopify's money format, the two forms a theme can meet. */
  function money(cents) {
    var n = (cents || 0) / 100;
    function group(v, dec) {
      var parts = v.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return FMT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      if (name === 'amount_no_decimals') { return group(n, 0); }
      if (name === 'amount_with_comma_separator') { return group(n, 2).replace(/,/g, ' ').replace('.', ','); }
      if (name === 'amount_no_decimals_with_comma_separator') { return group(n, 0).replace(/,/g, ' '); }
      return group(n, 2);
    });
  }

  /* ------------------------------------------------------------ reveal
     Every section head carries em-reveal, which is opacity 0 until this runs.
     If IntersectionObserver is missing the content is shown outright: a page
     that cannot animate must still be a page. */
  function reveal() {
    var els = $$('.em-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    /* Horizon scrolls .page-wrapper rather than the window, so that element is
       the observer's root. With the default root the first measurement is taken
       against a viewport nothing scrolls, and a section that is already on
       screen at load never gets its callback. */
    var io = new IntersectionObserver(function (rows) {
      rows.forEach(function (row) {
        if (row.isIntersecting) { row.target.classList.add('is-in'); io.unobserve(row.target); }
      });
    }, { root: $('.page-wrapper'), rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });

    /* A section head is hidden until this runs, so it must never depend on a
       slow page. Anything still hidden a moment later is shown outright: a
       missed animation is nothing, an invisible page is everything. */
    setTimeout(function () {
      $$('.em-reveal:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < (window.innerHeight || 0)) { el.classList.add('is-in'); }
      });
    }, 1200);
  }

  /* ------------------------------------------------------------ announcement */
  function announce() {
    var items = $$('.em-ann__item');
    if (items.length < 2) { return; }
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4200);
  }

  /* ------------------------------------------------------------ overlays */
  /* Horizon scrolls .page-wrapper, not the window: the lock has to go on the
     element that actually scrolls or the page slides behind the drawer. */
  function scroller() { return $('.page-wrapper') || document.documentElement; }
  function openDrawer() {
    var d = $('#em-drawer'); if (!d) { return; }
    d.classList.add('is-open');
    var s = $('#em-scrim'); if (s) { s.classList.add('is-on'); }
    scroller().style.overflow = 'hidden';
  }
  function closeAll() {
    $$('.em-drawer,.em-sheet,.em-modal').forEach(function (el) { el.classList.remove('is-open'); });
    var s = $('#em-scrim'); if (s) { s.classList.remove('is-on'); }
    scroller().style.overflow = '';
  }

  /* ------------------------------------------------------------ cart */
  var CART = null, deadline = null, ticker = null;

  function getCart() {
    return fetch(window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { CART = c; paint(); return c; });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
  }

  function bump() {
    $$('.em-cart-count').forEach(function (el) {
      el.classList.add('is-bump');
      setTimeout(function () { el.classList.remove('is-bump'); }, 260);
    });
  }

  function addToCart(id, qty, props) {
    var item = { id: id, quantity: qty || 1 };
    if (props) { item.properties = props; }
    return post('/cart/add.js', { items: [item] }).then(function (res) {
      if (!res.ok) { return Promise.reject(res.body && res.body.description); }
      bump();
      return getCart();
    });
  }

  function changeLine(key, qty) {
    return post('/cart/change.js', { id: key, quantity: qty }).then(function (res) {
      if (res.ok) { CART = res.body; paint(); }
    });
  }

  /* Ten minutes, and only when the shop has asked for it. Shopify does not hold
     stock before checkout, so the line is a setting that stays off unless the
     shop can stand behind it. */
  function holdHtml() {
    if (!window.EM_SHOW_HOLD) { return ''; }
    return '<div class="em-hold"><span class="em-hold__d"></span>' +
      '<span>Your cart is reserved for <b id="em-hold-left">10:00</b></span></div>';
  }
  function startTimer() {
    if (!window.EM_SHOW_HOLD) { return; }
    if (!deadline) { deadline = Date.now() + 600000; }
    if (ticker) { clearInterval(ticker); ticker = null; }
    function tick() {
      var el = $('#em-hold-left');
      if (!el) { clearInterval(ticker); ticker = null; return; }
      var left = Math.max(0, deadline - Date.now());
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (left <= 0) { clearInterval(ticker); ticker = null; deadline = null; }
    }
    tick();
    ticker = setInterval(tick, 1000);
  }

  /* A short row of real products the cart does not already hold. */
  function upsellHtml(cart) {
    if (!UPSELL.length) { return ''; }
    var have = {}, haveType = {};
    cart.items.forEach(function (l) {
      have[l.handle] = 1;
      if (l.product_type) { haveType[l.product_type] = 1; }
    });
    /* A bed missing its pillowcases wants pillowcases, not another duvet, so
       the kinds the cart has none of come first. */
    var picks = UPSELL.filter(function (p) { return !have[p.handle]; })
      .sort(function (a, b) {
        return (haveType[a.type] ? 1 : 0) - (haveType[b.type] ? 1 : 0);
      })
      .slice(0, 8);
    if (!picks.length) { return ''; }
    /* The card still opens the product; the button adds the variant named on
       the card (its first available one) without leaving the cart. */
    var cards = picks.map(function (p) {
      var price = p.variant ? p.variantPrice : p.price;
      return '<div class="em-cup__i"><a class="em-cup__a" href="' + p.url + '">' +
        (p.image ? '<span class="em-cup__m"><img src="' + p.image + '" alt="" loading="lazy"></span>' : '') +
        '<span class="em-cup__n">' + p.title + '</span>' +
        (p.variantTitle ? '<span class="em-cup__v">' + p.variantTitle + '</span>' : '') +
        '<span class="em-cup__p">' + money(price) + '</span></a>' +
        (p.variant ? '<button type="button" class="em-cup__add" data-cup-add="' + p.variant + '">Add to cart</button>' : '') +
        '</div>';
    }).join('');
    return '<div class="em-cup"><p class="em-cup__h">Goes with it</p>' +
      '<div class="em-cup__row">' + cards + '</div></div>';
  }

  function paint() {
    var c = CART;
    if (!c) { return; }
    $$('.em-cart-count').forEach(function (el) {
      el.textContent = c.item_count; el.setAttribute('data-count', c.item_count);
    });
    $$('.em-drawer-title').forEach(function (e) { e.textContent = 'Your cart (' + c.item_count + ')'; });

    var body = $('#em-drawer-body'), foot = $('#em-drawer-foot');
    if (!body || !foot) { return; }

    if (!c.item_count) {
      body.innerHTML = '<div class="em-empty"><p>Your cart is empty.</p>' +
        '<p style="margin-top:18px"><a class="em-link" href="/collections/all">See everything</a></p></div>';
      foot.innerHTML = '';
      return;
    }

    var sub = c.items_subtotal_price;
    var ship = '';
    if (FREE > 0) {
      var left = Math.max(0, FREE - sub);
      var pct = Math.min(100, (sub / FREE) * 100);
      ship = '<div class="em-ship">' +
        (left > 0 ? 'You are ' + money(left) + ' from free shipping.' : 'Free shipping unlocked.') +
        '<div class="em-ship__bar"><div class="em-ship__fill" style="width:' + pct + '%"></div></div></div>';
    }

    body.innerHTML = holdHtml() + ship + c.items.map(function (l) {
      var was = l.original_line_price, now = l.final_line_price;
      var pricing = was > now
        ? '<div class="em-li__p"><s>' + money(was) + '</s> ' + money(now) + '</div>'
        : '<div class="em-li__p">' + money(now) + '</div>';
      var img = l.image
        ? '<span class="em-lithumb"><img src="' + l.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') +
          '" alt="" loading="lazy"></span>'
        : '<span class="em-lithumb"></span>';
      var variant = l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '';
      return '<div class="em-li">' + img +
        '<div><div class="em-li__n">' + l.product_title + '</div>' +
        '<div class="em-li__v">' + variant + '</div>' +
        '<div class="em-li__q">' +
        '<button data-q="-1" data-key="' + l.key + '" aria-label="Remove one">&minus;</button>' +
        '<span>' + l.quantity + '</span>' +
        '<button data-q="1" data-key="' + l.key + '" aria-label="Add one">+</button></div></div>' +
        '<div>' + pricing +
        '<button class="em-li__x" data-key="' + l.key + '">Remove</button></div></div>';
    }).join('') + upsellHtml(c);

    /* The saving has to be visible in the cart, not only on the product page.
       It is Shopify's own figure: what the lines would have cost, less what
       they now cost. */
    var saved = c.items.reduce(function (s, l) {
      return s + Math.max(0, l.original_line_price - l.final_line_price);
    }, 0) + (c.total_discount || 0);

    foot.innerHTML =
      (saved > 0 ? '<div class="em-saved"><span>You save</span><span>' + money(saved) + '</span></div>' : '') +
      '<div class="em-sub"><span>Subtotal</span><span>' + money(c.total_price) + '</span></div>' +
      '<a class="em-btn em-btn--primary em-btn--block" href="/checkout">Checkout</a>' +
      '<p class="em-foot-note">Shipping and taxes are worked out at checkout.</p>';
    startTimer();
  }

  /* ------------------------------------------------------------ clicks */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-q]');
    if (q) {
      e.preventDefault();
      var line = CART && CART.items.filter(function (l) { return l.key === q.getAttribute('data-key'); })[0];
      if (line) { changeLine(line.key, line.quantity + Number(q.getAttribute('data-q'))); }
      return;
    }
    var x = e.target.closest('.em-li__x');
    if (x) { e.preventDefault(); changeLine(x.getAttribute('data-key'), 0); return; }

    var ca = e.target.closest('[data-cup-add]');
    if (ca) {
      e.preventDefault();
      if (ca.disabled) { return; }
      ca.disabled = true; ca.textContent = 'Adding';
      addToCart(ca.getAttribute('data-cup-add'), 1).catch(function (msg) {
        ca.textContent = msg || 'Not available';
        setTimeout(function () { ca.disabled = false; ca.textContent = 'Add to cart'; }, 2200);
      });
      return;
    }

    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-close]') || e.target.id === 'em-scrim') { closeAll(); return; }
    if (e.target.closest('[data-open-menu]')) { var sh = $('#em-sheet'); if (sh) { sh.classList.add('is-open'); } return; }
    if (e.target.closest('[data-open-search]')) {
      e.preventDefault();
      var s = $('#em-search');
      if (s) { s.classList.add('is-open'); setTimeout(function () { var i = $('#em-search-input'); if (i) { i.focus(); } }, 60); }
      return;
    }

    /* A colour dot on a card swaps the card's photograph. */
    var dot = e.target.closest('.em-card .em-dot[data-swap]');
    if (dot) {
      e.preventDefault();
      var card = dot.closest('.em-card');
      /* em-card__shot is the frame; the picture is the img inside it. The
         srcset has to go too, or the browser keeps serving the old colour. */
      var img = $('.em-card__shot img', card);
      if (img) {
        /* Still lazy from the server render, so it would sit unfetched even
           once the src changes. Ask for it outright. */
        img.setAttribute('loading', 'eager');
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = dot.getAttribute('data-swap');
      }
      $$('.em-dot', card).forEach(function (d) { d.classList.remove('is-on'); });
      dot.classList.add('is-on');
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); } });

  /* Any product form posts through the cart API so the drawer can open. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) { return; }
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) { return; }
    var qty = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('button[type="submit"], .em-card__quick');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }
    addToCart(id.value, qty ? Number(qty.value) : 1)
      .then(function () {
        if (btn) {
          btn.classList.add('is-done');
          btn.textContent = 'Added';
          setTimeout(function () {
            btn.disabled = false; btn.classList.remove('is-done'); btn.textContent = label;
          }, 1400);
        }
        openDrawer();
      })
      .catch(function (msg) {
        if (btn) { btn.disabled = false; btn.textContent = msg || 'Not available'; 
          setTimeout(function () { btn.textContent = label; }, 2200); }
      });
  });

  /* ------------------------------------------------------------ search
     Shopify's own suggestions, so a result is never a product that is not
     there. Submitting goes to the real search page. */
  var si = null, stimer = null;
  function suggest(q) {
    var out = $('#em-search-results');
    if (!out) { return; }
    q = q.trim();
    if (q.length < 2) { out.innerHTML = ''; return; }
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last',
      { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = ((d.resources || {}).results || {}).products || [];
        if (!ps.length) {
          out.innerHTML = '<p class="em-lede">Nothing matches that yet.</p>';
          return;
        }
        out.innerHTML = '<p class="em-eyebrow" style="margin-bottom:16px">' + ps.length +
          (ps.length === 1 ? ' piece' : ' pieces') + '</p>' +
          '<div class="em-grid em-grid--p">' + ps.map(function (p) {
            var shot = p.featured_image && p.featured_image.url
              ? '<img class="em-card__shot" src="' + p.featured_image.url + '" alt="" loading="lazy">' : '';
            return '<article class="em-card">' +
              '<div class="em-card__top"><a class="em-card__media" href="' + p.url + '">' + shot + '</a></div>' +
              '<a class="em-card__name" href="' + p.url + '">' + p.title + '</a>' +
              '<div class="em-card__spec">' + (p.type || '') + '</div>' +
              '<div class="em-card__price">' +
                (p.price_min && p.price_max && p.price_min !== p.price_max
                  ? '<span class="em-card__from">From </span>' : '') +
                (p.price ? money(Math.round(Number(p.price) * 100)) : '') + '</div>' +
              '<div class="em-card__sw"></div></article>';
          }).join('') + '</div>';
      });
  }

  /* ------------------------------------------------------------ nav fit
     The wordmark is centred, so the nav has a fixed column to live in. Rather
     than wrap or overflow, links are dropped from the end until the row fits,
     exactly as the approved build does. They stay in the phone menu, which
     lists every link.  */
  function fitNav() {
    var nav = $('.em-nav'), start = $('.em-header__start');
    if (!nav || !start || getComputedStyle(nav).display === 'none') { return; }
    /* Hide the wrapper, not the link inside it. Hiding the link left the
       span in the flex row, so every dropped item still spent an 18px gap:
       five hidden links wasted 90px, the row never measured as short as it
       really was, and the loop went on dropping categories that did fit. */
    var items = $$('.em-nav__i', nav);
    items.forEach(function (i) { i.hidden = false; });
    var avail = start.clientWidth - 24;
    for (var i = items.length - 1; i >= 0 && nav.scrollWidth > avail; i--) {
      items[i].hidden = true;
    }
  }
  window.addEventListener('resize', fitNav);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fitNav); }
  setTimeout(fitNav, 60);

  function start() {
    reveal();
    announce();
    fitNav();
    getCart();
    si = $('#em-search-input');
    if (si) {
      si.addEventListener('input', function () {
        clearTimeout(stimer);
        var v = si.value;
        stimer = setTimeout(function () { suggest(v); }, 180);
      });
    }
    /* A mega menu panel opens on its own nav item. */
    $$('.em-nav__i').forEach(function (item) {
      var panel = $('.em-mm', item);
      if (!panel) { return; }
      function open() { panel.hidden = false; }
      function shut() { panel.hidden = true; }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', shut);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) { shut(); }
      });
    });
  }

  if (document.readyState !== 'loading') { start(); } else {
    document.addEventListener('DOMContentLoaded', start);
  }
  /* The theme editor rebuilds a section in place; re-run what that section needs. */
  window.addEventListener('load', function () { reveal(); fitNav(); });
  document.addEventListener('shopify:section:load', function () { reveal(); announce(); fitNav(); paint(); });
  window.EM = { addToCart: addToCart, getCart: getCart, openDrawer: openDrawer, money: money };
  /* AOV.ai does not know this drawer and reloads the page after every cart
     change it makes. It calls window.monster_refresh first when one exists, so
     give it one: repaint the drawer from /cart.js and leave it open or shut. */
  window.monster_refresh = function () { getCart(); return true; };

  /* AOV.ai allows one badge per offer, set on the middle tier. The last tier
     gets a copy of that badge reading "Best Value", so it is styled exactly
     the same. AOV redraws the widget when a tier is picked, so watch for it. */
  function bestValue() {
    var box = $('.Avada-Bundle-Volume__Container'); if (!box) { return; }
    var items = $$('.Avada-Volume__Item', box);
    if (items.length < 3) { return; }
    var last = items[items.length - 1];
    if ($('.Avada-VolumeBoxBadge', last)) { return; }
    var src = $('.Avada-VolumeBoxBadge', box); if (!src) { return; }
    var b = src.cloneNode(true);
    b.removeAttribute('style');
    $('.Avada-BadgeText', b).textContent = 'Best Value';
    last.insertBefore(b, last.firstChild);
  }
  var slot = $('#em-offer-slot');
  if (slot && window.MutationObserver) {
    new MutationObserver(bestValue).observe(slot.parentNode, { childList: true, subtree: true });
    bestValue();
  }
})();
